import NotFound from "@/components/error/NotFound";
import type { Route } from "./+types/not-found";

export const meta: Route.MetaFunction = () => {
  return [{ title: "404 - Page Not Found" }];
};

export default function NotFoundRoute() {
  return <NotFound />;
}

